import {
  Folder, File, FileText, FileType, FileSpreadsheet, FileType2,
  FileAudio, FileVideo, FileImage, FileArchive, FileCode, Presentation,
} from "lucide-react";

const EXT = {
  // Word
  doc: { Icon: FileType, color: "text-blue-600" },
  docx: { Icon: FileType, color: "text-blue-600" },
  cdoc: { Icon: FileType, color: "text-blue-600" },
  rtf: { Icon: FileType, color: "text-blue-600" },
  odt: { Icon: FileType, color: "text-blue-600" },
  // Excel
  xls: { Icon: FileSpreadsheet, color: "text-green-600" },
  xlsx: { Icon: FileSpreadsheet, color: "text-green-600" },
  csheet: { Icon: FileSpreadsheet, color: "text-green-600" },
  csv: { Icon: FileSpreadsheet, color: "text-green-600" },
  ods: { Icon: FileSpreadsheet, color: "text-green-600" },
  // PowerPoint
  ppt: { Icon: Presentation, color: "text-orange-500" },
  pptx: { Icon: Presentation, color: "text-orange-500" },
  // PDF
  pdf: { Icon: FileType2, color: "text-red-600" },
  // Audio
  mp3: { Icon: FileAudio, color: "text-violet-500" },
  wav: { Icon: FileAudio, color: "text-violet-500" },
  m4a: { Icon: FileAudio, color: "text-violet-500" },
  aac: { Icon: FileAudio, color: "text-violet-500" },
  ogg: { Icon: FileAudio, color: "text-violet-500" },
  flac: { Icon: FileAudio, color: "text-violet-500" },
  // Video
  mp4: { Icon: FileVideo, color: "text-rose-500" },
  mov: { Icon: FileVideo, color: "text-rose-500" },
  avi: { Icon: FileVideo, color: "text-rose-500" },
  mkv: { Icon: FileVideo, color: "text-rose-500" },
  webm: { Icon: FileVideo, color: "text-rose-500" },
  // Image
  png: { Icon: FileImage, color: "text-sky-500" },
  jpg: { Icon: FileImage, color: "text-sky-500" },
  jpeg: { Icon: FileImage, color: "text-sky-500" },
  gif: { Icon: FileImage, color: "text-sky-500" },
  webp: { Icon: FileImage, color: "text-sky-500" },
  svg: { Icon: FileImage, color: "text-sky-500" },
  bmp: { Icon: FileImage, color: "text-sky-500" },
  heic: { Icon: FileImage, color: "text-sky-500" },
  // Archive
  zip: { Icon: FileArchive, color: "text-amber-600" },
  rar: { Icon: FileArchive, color: "text-amber-600" },
  "7z": { Icon: FileArchive, color: "text-amber-600" },
  tar: { Icon: FileArchive, color: "text-amber-600" },
  gz: { Icon: FileArchive, color: "text-amber-600" },
  // Code
  js: { Icon: FileCode, color: "text-yellow-500" },
  jsx: { Icon: FileCode, color: "text-yellow-500" },
  ts: { Icon: FileCode, color: "text-blue-500" },
  py: { Icon: FileCode, color: "text-emerald-500" },
  html: { Icon: FileCode, color: "text-orange-600" },
  css: { Icon: FileCode, color: "text-blue-400" },
  json: { Icon: FileCode, color: "text-slate-500" },
  xml: { Icon: FileCode, color: "text-slate-500" },
  // Plain text
  txt: { Icon: FileText, color: "text-slate-500" },
  md: { Icon: FileText, color: "text-slate-500" },
  log: { Icon: FileText, color: "text-slate-500" },
};

const extOf = (name) => {
  const m = /\.([a-z0-9]+)$/i.exec(name || "");
  return m ? m[1].toLowerCase() : "";
};

// Returns { Icon, color } for a desktop_nodes row (folder or file).
export function fileIcon(node) {
  if (!node) return { Icon: File, color: "text-slate-400" };
  if (node.type === "folder") return { Icon: Folder, color: "text-amber-400" };
  const byExt = EXT[extOf(node.name)];
  if (byExt) return byExt;
  const ct = node.content_type || "";
  if (ct.startsWith("image/")) return { Icon: FileImage, color: "text-sky-500" };
  if (ct.startsWith("audio/")) return { Icon: FileAudio, color: "text-violet-500" };
  if (ct.startsWith("video/")) return { Icon: FileVideo, color: "text-rose-500" };
  if (ct === "application/pdf") return { Icon: FileType2, color: "text-red-600" };
  return { Icon: File, color: "text-slate-400" };
}
